import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import Icon from 'wonderbly-components/lib/Icon';
import { optimiseImage } from 'src/common/utils/prismic-image';
import RichText from '../../Prismic/RichText';
import Price from '../../Price';
import EditableContent from './EditableContent';

const FixedContent = props => (
  <React.Fragment>
    {!isEmpty(props.expandedCustomisation) ? (
      <span className="line-item-customisation">
        <RichText fields={props.expandedCustomisation} />
      </span>
    ) : (
      <React.Fragment>
        <span className="line-item-customisation">{props.customisationString || ''}</span>
        <span className="line-item-option">
          {props.type}
          {!isEmpty(props.addons) && props.addons.map(addon => ` + ${addon.label}`)}
        </span>
      </React.Fragment>
    )}
  </React.Fragment>
);

FixedContent.propTypes = {
  expandedCustomisation: PropTypes.array,
  customisationString: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  addons: PropTypes.array.isRequired,
};

const LineItemContent = props => (
  <React.Fragment>
    <div className="line-item-image-wrapper" key="line-item-image-wrapper">
      {props.image && [
        <img
          key="default-image"
          src={optimiseImage(props.image.url, {
            auto: 'format,compress',
            w: props.image.dimensions.width,
          })}
          alt={props.image.alt || ''}
          className={cx('line-item-image', {
            'line-item-image-ii--default': !isEmpty(props.addons)
          })}
        />,
        props.addons.map(addon => (
          <img
            key={`addon-image-${addon.id}`}
            src={optimiseImage(addon.image.url, {
              auto: 'format,compress',
              w: get(addon, 'image.dimensions.width', 0),
            })}
            alt={addon.image.alt || ''}
            className="line-item-image line-item-image--addon"
          />
        )),
      ]}
    </div>
    <div className="line-item-content" key="line-item-content">
      <div>
        <h3 className="line-item-title">{props.title || ''}</h3>
        {props.isEditable ? <EditableContent {...props} /> : <FixedContent {...props} />}
      </div>
      <Price className="line-item-price" price={props.price} savings={props.savings} savingPriceString={props.savingsPriceLabel} savingsType="saved" />
    </div>
    {props.isRemovable && (
      <button
        key="line-item-delete"
        onClick={props.onRemove}
        className="line-item-delete">
        <Icon icon="delete" />
      </button>
    )}
  </React.Fragment>
);

LineItemContent.propTypes = {
  isEditable: PropTypes.bool,
  isRemovable: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
  image: PropTypes.object,
  addons: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  price: PropTypes.object,
  savings: PropTypes.object,
  savingsPriceLabel: PropTypes.string
};

export default LineItemContent;



// WEBPACK FOOTER //
// ./src/client/js/view/components/CartItems/LineItem/LineItemContent.js